// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Remove from "@adl/XDL/Icons/Remove";
import { mergeWithCss, xFirefoxOnly } from "@adl/XDL/Utilities";
import color from "@adl/XDL/Utilities/color";
import { rfqQuoteDetailsQuoteLineCalculatorStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculatorRow";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

rfqQuoteDetailsQuoteLineCalculatorStyles.priceTextField = {
    cssOverrides: {
        formField: css`
            width: 100px;
        `,
        inputSelect: css`
            text-align: center;
        `,
    },
};

rfqQuoteDetailsQuoteLineCalculatorStyles.priceCell = {
    css: css`
        height: 60px;
        border-bottom: none;
        padding-top: 10px;
    `,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.qtyCell = {
    ...mergeWithCss(rfqQuoteDetailsQuoteLineCalculatorStyles.qtyCell, {
        css: css`
            ${xFirefoxOnly(`
            > div[class^="FormFieldStyle"] {
                margin-right: 40px;
            }
            position: relative;
        `)}
        `,
    }),
};

rfqQuoteDetailsQuoteLineCalculatorStyles.toLabelText = {
    ...mergeWithCss(rfqQuoteDetailsQuoteLineCalculatorStyles.toLabelText, {
        css: css`
            ${xFirefoxOnly(`
                position: absolute;
                top: 18px;
                left: 88px;
                display: inline-block;
            `)}
        `,
    }),
};

rfqQuoteDetailsQuoteLineCalculatorStyles.removePriceBreakLink = {
    css: css`
        & {
            span {
                color: ${color("danger", 0.75)};
                ${IconWrapper} {
                    color: ${color("danger", 0.75)};
                }
            }
        }
        &:hover {
            span {
                color: ${color("danger")};
                ${IconWrapper} {
                    color: ${color("danger")};
                }
            }
        }
    `,
};
rfqQuoteDetailsQuoteLineCalculatorStyles.removePriceBreakIcon = {
    src: Remove,
    size: 16,
};
